import React, { Component } from 'react';
import Modal from 'react-modal';
import { withRouter } from 'react-router-dom';
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils';
import AddEmailModalUI from './AddEmailModalUI';

class AddEmailModalSF extends Component {
  constructor(props) {
    super(props);

    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      email: '',
      emailError: null,
    };
  }

  render() {
    return (
      <AddEmailModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // Event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.onAddEmailCancel}
        // Modes
        createMode={this.props.createMode}
        submitted={this.state.submitted}
        // Form fields
        email={this.state.email}
        onEmailChange={(event) => this.setState({ email: event.target.value })}
        emailError={this.state.emailError}
        setEmailError={(error) => this.setState({ emailError: error })}
      />
    );
  }

  componentDidMount() {
    Modal.setAppElement('body');
  }

  componentDidUpdate(prevProps) {
    if (!prevProps || !this.props.messageApprovalId) return;
    if (prevProps.messageApprovalId !== this.props.messageApprovalId) {
      this.setState({ email: '' });
    }
  }

  onAddEmailCancel = () => {
    this.props.onAddEmailCancel()
  }

  onSubmit = () => {
    if (this.state.submitted) return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true,
    })

    RestApiUtils.post(
      this.props.context,
      `/api/su/messages/approvals/${this.props.message.messageApprovalId}/addEmail`,
      this.onSubmitCallback,
      { email: this.state.email }
    );
  }

  onSubmitCallback = (response) => {
    let errorList = [];
    if (response && response.errorList) {
      errorList = response.errorList.map((error) => error.message);
    }

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false,
    });

    if (errorList.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null });
        this.props.onAddEmailCancel();
        this.props.onRefreshClick();
      }, 2000);
    }
  };

  setErrorList = (errorList) => {
    this.setState({ errorList });
  };
}

export default withRouter(AddEmailModalSF);
